import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Formik, Form, Field } from "formik"
import { Bounce, toast } from "react-toastify"
import { Container, FormGroup, FormFeedback, Input, Label } from "reactstrap"
import * as Yup from "yup"
import { post, get, put } from "api/axios"
import endpoints from "api/endpoints"

export default function AddCoupon() {
  const navigate = useNavigate()
  const { id = null } = useParams()
  const [coupon, setCoupon] = useState()

  const getCouponContent = async () => {
    const resp = await get(`${endpoints.coupon}/${id}`)

    if (resp?.data?.success) {
      setCoupon(resp?.data?.data)
      console.log(resp?.data?.data, "resp?.data?.data")
    }
  }
  useEffect(() => {
    id != null && getCouponContent()
  }, [id])
  const generateCouponCode = (prefix, discount, length = 6) => {
    const randomPart = Math.random()
      .toString(36)
      .substring(2, length + 2)
      .toUpperCase()
    return `${prefix}${discount}${randomPart}`
  }
  return (
    <section id="add-coupons" className="page-content">
      <Container fluid>
        <div>
          <div>
            <span className="font-size-26 text-darkcolor text-uppercase fw-medium">
              {id != null ? "Edit Coupon" : "Add New Coupon"}{" "}
              <small>
                <i>{coupon?.discountCode ? `"coupon?.discountCode"` : ``}</i>
              </small>
            </span>
          </div>

          <Formik
            enableReinitialize
            initialValues={{
              value: coupon?.value.$numberDecimal || "",
              description: coupon?.description || "",
              discountCode: coupon?.discountCode || "",
              discountCodeType: coupon?.discountCodeType || "percentage",
            }}
            validationSchema={Yup.object({
              description: Yup.string().required(
                "Please enter the description"
              ),
              discountCodeType: Yup.string()
                .oneOf(["percentage", "fixed"], "Invalid discountCodeType")
                .required("discountCodeType is required"),
              value: Yup.number()
                .typeError("Value must be a number")
                .when("discountCodeType", {
                  // Note the case-sensitive field name
                  is: "percentage",
                  then: () =>
                    Yup.number()
                      .min(1, "Value must be at least 1")
                      .max(100, "Value cannot exceed 100")
                      .required("Value is required for percentage"),
                  otherwise: () =>
                    Yup.number()
                      .min(0.01, "Value must be at least 0.01")
                      .max(4.99, "Value cannot exceed 4.99")
                      .required("Value is required for fixed"),
                }),
            })}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              let response
              setSubmitting(true)
              if (id != null) {
                response = await put(`${endpoints.coupon}/${id}`, values)
              } else {
                const code = generateCouponCode(
                  `DOCKIES${
                    values.discountCodeType == "percentage" ? "P" : "F"
                  }`,
                  values.value,
                  3
                )
                response = await post(endpoints.coupon, {
                  ...values,
                  discountCode: code,
                })
              }

              if (response.status === 200 || response.status === 202) {
                id != null
                  ? toast.success("Coupon Updated Successfully", {
                      position: "bottom-center",
                      theme: "colored",
                      transition: Bounce,
                    })
                  : toast.success("Coupon Added Successfully", {
                      position: "bottom-center",
                      theme: "colored",
                      transition: Bounce,
                    })

                resetForm()
                navigate("/coupon")
              } else {
                setSubmitting(false)
                toast.error("Coupon Already Exists", {
                  position: "bottom-center",
                  theme: "colored",
                  transition: Bounce,
                })
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              formProps,
              resetForm,
              setValues,
              /* and other goodies */
            }) => {
              return (
                <Form>
                  <div className="card p-3 shadow rounded-4">
                    <div className="row">
                      <div className="col-12 col-md-6 g-3 ">
                        <FormGroup floating>
                          <Input
                            id="awrds-type"
                            name="discountCodeType"
                            placeholder="Coupon Type"
                            type="select"
                            className="rounded-4 border-2 green-border"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.discountCodeType || ""}
                            invalid={
                              touched.discountCodeType &&
                              errors.discountCodeType
                                ? true
                                : false
                            }
                          >
                            <option value={"percentage"} key={0}>
                              Percentage
                            </option>
                            <option value={"fixed"} key={1}>
                              Fixed
                            </option>
                          </Input>
                          <Label for="awrds-type" className="text-uppercase">
                            Coupon Category
                          </Label>
                          {touched.discountCodeType &&
                          errors.discountCodeType ? (
                            <FormFeedback type="invalid">
                              {errors.discountCodeType}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </div>

                      <div className="col-12 col-md-6 g-3">
                        <FormGroup floating>
                          <Input
                            id="coupon-cat"
                            name="value"
                            placeholder="Value Category"
                            type="text"
                            className="rounded-4 border-2 green-border"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.value || ""}
                            invalid={
                              touched.value && errors.value ? true : false
                            }
                          />
                          <Label for="value-cat" className="text-uppercase">
                            Value
                          </Label>
                          {touched.value && errors.value ? (
                            <FormFeedback type="invalid">
                              {errors.value}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </div>

                      <div className="col-12 col-md-12 g-3">
                        <FormGroup floating>
                          <Input
                            id="description-cat"
                            name="description"
                            placeholder="Description Category"
                            type="text"
                            className="rounded-4 border-2 green-border"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.description}
                            invalid={
                              touched.description && errors.description
                                ? true
                                : false
                            }
                          />
                          <Label
                            for="description-cat"
                            className="text-uppercase"
                          >
                            Description
                          </Label>
                          {touched.description && errors.description ? (
                            <FormFeedback type="invalid">
                              {errors.description}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </div>
                    </div>
                    <div className="d-flex gap-3 justify-content-end mt-3">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn btn-primary-green text-uppercase"
                      >
                        {id ? "Update Coupon" : "Add Coupon"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary text-uppercase"
                        onClick={() => resetForm()}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              )
            }}
          </Formik>
        </div>
      </Container>
    </section>
  )
}
